import { useEffect, useRef } from 'react';

export const usePrevious = <T>(newValue: T): T | undefined => {
  const previousRef = useRef<T | undefined>(undefined);
  useEffect(() => {
    previousRef.current = newValue;
  });
  return previousRef.current;
};
